import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import unableToAcceptInvite from 'assets/unable-to-accept-invite.png';

import { ROUTES } from 'routes/route.constants';

import InviteFlowLayout from './InviteFlowLayout';

import styles from './InviteFlow.module.scss';

const UnableToAccept = ({ title }) => {
  const navigate = useNavigate();

  const handleLearnMore = () => {
    navigate(ROUTES.LANDING);
  };

  return (
    <InviteFlowLayout>
      <img
        src={unableToAcceptInvite}
        alt={title}
        className={styles['illustration']}
      />

      <div className={styles['text-group']}>
        <h1 className={styles['screen-title']}>
          {title}
        </h1>
        <p className={styles['screen-subtitle']}>
          If you think this is a mistake, please contact the workspace admin to help you
        </p>
      </div>

      <button
        type="button"
        onClick={handleLearnMore}
        className={styles['cta-button-outline']}
      >
        Learn about onBeacon
      </button>
    </InviteFlowLayout>
  );
};

UnableToAccept.propTypes = {
  title: PropTypes.string,
};

UnableToAccept.defaultProps = {
  title: 'Unable to accept invitation',
};

export default UnableToAccept;
